import React, {useState } from 'react';

export const SalubrisContext = React.createContext();

export const Provider = (props) => {
    const [centers, setCenters] = useState([]);
  
    const handleCentersChange = (centers) => {
    
      setCenters(centers);
      localStorage.setItem( 'centers', JSON.stringify(centers));
    };
  
    return (
      <SalubrisContext.Provider value={{ 
        centers,
        actions: {
          setCenters: handleCentersChange
        }
      }}>
        { props.children }
      </SalubrisContext.Provider>
    );
}